var map = {
	"./ark/translations/es/translation.json": 5210,
	"./bridge_positive/translations/es/translation.json": 2499,
	"./criptokuantica/translations/es/translation.json": 1547,
	"./deptoken/translations/es/translation.json": 3880,
	"./domum/translations/es/translation.json": 684,
	"./fuegos/translations/es/translation.json": 5421,
	"./horizonte/translations/es/translation.json": 5250,
	"./impozo/translations/es/translation.json": 3790,
	"./muskuy/translations/es/translation.json": 6328
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 3515;